import React from 'react';
import { motion } from 'framer-motion';
import { asset } from '@/lib/api';
import { EASE } from '@/lib/motion';

export const Vision = ({ about }) => {
  if (!about?.vision) return null;
  const words = about.vision.split(' ');
  return (
    <section className='relative overflow-hidden bg-[#F6F5F1]'>
      <div className='container-x py-24 lg:py-32'>
        <div className='flex items-center gap-3'>
          <span className='h-px w-8 bg-[#B88A3B]' />
          <span className='eyebrow text-[#075B61]'>{about.visionEyebrow || 'Our Vision'}</span>
        </div>
        <motion.p
          className='mt-8 max-w-5xl font-head text-2xl font-medium leading-[1.35] tracking-[-0.01em] text-[#20272A] sm:text-3xl lg:text-[2.6rem] lg:leading-[1.32]'
          initial='hidden'
          whileInView='show'
          viewport={{ once: true, margin: '-100px' }}
          transition={{ staggerChildren: 0.012 }}
        >
          {words.map((w, i) => (
            <motion.span
              key={i}
              className='inline-block pr-[0.26ch]'
              variants={{ hidden: { opacity: 0.12 }, show: { opacity: 1, transition: { duration: 0.5, ease: EASE } } }}
            >
              {w}
            </motion.span>
          ))}
        </motion.p>
      </div>
    </section>
  );
};
